import "./TablePagination.css";
import DynamicButton from "../DynamicButton/DynamicButton";

const TablePagination = ({
  currentPage,
  totalPages,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
  totalEntries,
}) => (
  <div className="custom-pagination">
    {/* Entries Per Page */}
    <div className="custom-page-size">
      <label htmlFor="pageSize">Show </label>
      <select
        id="pageSize"
        value={itemsPerPage}
        onChange={(e) => {
          setItemsPerPage(Number(e.target.value));
          setCurrentPage(1); // reset to first page
        }}
      >
        <option value={10}>10</option>
        <option value={25}>25</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
      </select>
      <span> entries</span>
    </div>

    {/* Prev Button */}
    <DynamicButton
      text="Prev"
      icon="fa-chevron-left"
      size="sm"
      variant="outline"
      disabled={currentPage === 1}
      onClick={() => setCurrentPage((prev) => prev - 1)}
    />

    {/* Page Info */}
    <span className="custom-pagination-info">
      Page {currentPage} of {totalPages}
    </span>

    {/* Next Button */}
    <DynamicButton
      text="Next"
      icon="fa-chevron-right"
      size="sm"
      variant="outline"
      disabled={currentPage === totalPages}
      onClick={() => setCurrentPage((prev) => prev + 1)}
    />

    {/* Total Count */}
    <div className="custom-total-count">
      Total: <strong>{totalEntries}</strong>
    </div>
  </div>
);

export default TablePagination;
